'use strict';

module.exports = 'enhance';


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/var/ENHANCEMENTS_FLAG.js
// module id = 34
// module chunks = 0